var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11115",
    "data-name": "Grupo 11115",
    transform: "translate(-1178.5 -882.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "translate(1204 883) rotate(90)",
    fill: "#DDDDDD",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45259",
    "data-name": "Trazado 45259",
    d: "M-1256.822,8111.429l4.19,4.561-4.19,4",
    transform: "translate(9307.209 2151.037) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIconBlack);
export default __webpack_public_path__ + "static/media/SelectIcon-black.99591273ac2064e6dcf2db1694ec4f66.svg";
export { ForwardRef as ReactComponent };